import * as Yup from 'yup'
import LookupType from './LookupType'


const PebbleDetails = Yup.object().shape({
    id: Yup.number(),
    job_detail_id: Yup.number().nullable(),
    request_date: Yup.string().nullable(),
    total_batches: Yup.number().nullable(),
    
    color_additions: Yup.array().of(Yup.object().shape({
        id: Yup.number(),
        job_detail_id: Yup.number(),
        color: LookupType.nullable(),
        material_type: LookupType.nullable(),
        pool_section: LookupType.nullable(),
        additions: Yup.array().of(LookupType),
        batches_used: Yup.string().nullable(),
        notes: Yup.string().nullable()
    })),

    crew_information: Yup.array().of(Yup.object().shape({
        id: Yup.number(),
        job_detail_id: Yup.number(),
        date: Yup.string().nullable(),
        crew: LookupType.nullable(),
        foreman: LookupType.nullable(),
        phase_type: LookupType.required('You must select a phase').typeError('You must select a phase'),
        job_order: LookupType.nullable(),
        type: Yup.string().nullable(),
        notes: Yup.string().nullable(),
        status: LookupType.nullable(),
        slurry_pickup: LookupType.nullable()
    })).nullable()
})

const SubjobSchema = Yup.object().shape({
    id: Yup.number().nullable(),
    job_category: LookupType,
    status: LookupType.nullable(),

    pebble_details: PebbleDetails,
    mmg_ia: Yup.string().nullable(),
    depth_low: Yup.string().nullable(),
    depth_mid: Yup.string().nullable(),
    depth_high: Yup.string().nullable(),
    mmg_pebble_perimeter: Yup.string().nullable(),
    awaiting_builder_date: Yup.string().nullable()
})

export const DailyBatchesSchema = Yup.object().shape({
    id: Yup.string().nullable(),

    sub_jobs: Yup.array().of(SubjobSchema)
})